import EastIcon from "@mui/icons-material/East"
import { Stack, Typography } from "@mui/material"
import { FC } from "react"

import styles from "../IncidentOverview.module.scss"
import { Button } from "src/components/common/button"
import { create } from "src/helpers/bem"
import { useTranslation } from "src/hooks/translation"
import { mergeDialog } from "src/states/dialogs"

const bem = create(styles, "IncidentOverview")

export const CreateRequestCard: FC = () => {
  const { messages: translations } = useTranslation()
  const incidentsTranslations =
    translations.pages.account.overview.profile.incidents.cards.createRequest

  return (
    <Stack className={bem("card")} direction={"column"}>
      <div className={bem("card", "header")}>
        <Typography variant="subtitle1">
          {incidentsTranslations.title}
        </Typography>
      </div>
      <Stack
        className={bem("card", "content")}
        direction={"row"}
        justifyContent={"space-between"}
      >
        <Stack direction={"column"} maxWidth={"70%"} spacing={2}>
          <Typography variant={"body1"}>
            {incidentsTranslations.info1}
          </Typography>
          <Typography variant={"body1"}>
            {incidentsTranslations.info2}
          </Typography>
        </Stack>
        <Stack direction={"column"} spacing={2}>
          <Button
            buttonType="primary"
            className={bem("button")}
            endIcon={<EastIcon fontSize="small" />}
            title={incidentsTranslations.buttons.createIncident}
            onClick={() =>
              mergeDialog("incidentDialog", { open: true, disabled: false })
            }
          />
        </Stack>
      </Stack>
    </Stack>
  )
}
